import { Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, of, concat } from 'rxjs';
import { map } from 'rxjs/operators';

import { TenantUserService } from '../../user/services/tenant-user.service';
import { arrayToPropertyValueRecord } from '../utils/array-to-record';

@Pipe({
  standalone: true,
  name: 'userNameResolver$',
})
export class UserNameResolverPipe implements PipeTransform {
  private readonly service = inject(TenantUserService);

  public transform(userId: string): Observable<string> {
    if (!userId) {
      return of(userId);
    }

    return concat(
      of(userId),
      this.service.getManageableTenantUsers(true).pipe(
        map((users) => arrayToPropertyValueRecord(users, 'userId', 'displayName')),
        map((lookup) => lookup[userId] || userId)
      )
    );
  }
}
